import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import UrlParse from 'url-parse';
import _ from 'lodash';
import { useRecoilState, useRecoilCallback } from 'recoil';
import { authenticationSelector } from '../../stores/authentication/selectors';
import { roomSelector } from '../../stores/room/selectors';
import useModal from '../../hooks/useModal';
import service from '../../service';
import { Input, ConfirmButton, BackButton, Label, ImgWrapper, Img } from './styled';

const UnauthorizedComponent = ({ back, showBack }) => {
    return (
        <div className={'flex flex-col justify-center items-center'}>
            <div className={'py-4px pt-16px text-center'}>
                <Label level={1} type={'warning'}>
                    Access Denied!
                </Label>
            </div>
            <div className={'py-4px text-center'}>
                <Label type={'warning'}>การเข้าถึงถูกปฏิเสธ</Label>
            </div>
            {showBack && <BackButton onClick={() => back()}>Back</BackButton>}
        </div>
    );
};

const PasswordConfirmationComponent = ({ join, isLoading }) => {
    const [password, setPassword] = useState();

    return (
        <div className={'flex flex-col justify-center items-center'}>
            <ImgWrapper>
                <Img src={'/resources/images/logo-hospital.svg'} />
            </ImgWrapper>
            <div className={'py-4px text-center'}>
                <Label>กรุณาระบุรหัสผ่าน / วันเดือนปี(ค.ศ) เกิด</Label>
            </div>
            <div className={'py-4px text-center'}>
                <Label>Please enter your password / Date of Birth</Label>
            </div>
            <div className={'w-full py-8px'}>
                <Input
                    type={'password'}
                    name={'roomId'}
                    placeholder={'DDMMYYYY'}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </div>
            <ConfirmButton
                disabled={_.isEmpty(password) ? 'disabled' : null}
                onClick={() => join({ password })}
            >
                {isLoading && 'Confirm'}
                {!isLoading && 'Confirm'}
            </ConfirmButton>
        </div>
    );
};

const AuthContainer = () => {
    const { open, close } = useModal();
    const [authenticationStore, setAuthenticationStore] = useRecoilState(authenticationSelector);
    const [isAuthFail, setIsAuthFail] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const urlParser = new UrlParse(window.location.href, true);
    const hasSessionQs = !_.isNil(urlParser.query.session);
    const join = useRecoilCallback(({ snapshot }) => async ({ password }) => {
        const { roomId } = await snapshot.getPromise(roomSelector);
        setIsLoading(true);
        service
            .joinRoom(roomId, password)
            .then((res) => {
                if (res.code === 200) {
                    close(() => {
                        setAuthenticationStore({
                            authorized: res.data.authorized,
                            role: res.data.role,
                            displayName: res.data.displayName,
                            session: res.data.session,
                        });
                    });
                } else {
                    setIsAuthFail(true);
                }
            })
            .catch(() => {
                setIsAuthFail(true);
            });
    });
    const back = useCallback(() => {
        setIsAuthFail(false);
    });

    useEffect(() => {
        if (!hasSessionQs || isAuthFail || authenticationStore.authorized === false) {
            open({
                content: (
                    <UnauthorizedComponent
                        back={back}
                        showBack={(authenticationStore.bypass && hasSessionQs) || isAuthFail}
                    />
                ),
            });
        } else {
            open({
                content: <PasswordConfirmationComponent join={join} isLoading={isLoading} />,
            });
        }
    }, [isAuthFail]);

    return <div></div>;
};

UnauthorizedComponent.propTypes = {
    back: PropTypes.func.isRequired,
    showBack: PropTypes.bool.isRequired,
};

PasswordConfirmationComponent.propTypes = {
    join: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
};

export default AuthContainer;
